const PageSizeSelector = (pageSizes, onPageSizeChange) =>
  pageSizes.map(size => {
    return {
      value: size,
      title: `${size} rows`,
      onClick: (e) => onPageSizeChange(parseInt(e.target.getAttribute('value'))),
      variant: 'primary'
    }
  })

export default PageSizeSelector
